var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unit-curve w-full h-full"},[_c('div',{staticClass:"chart-unit"},[(_vm.showChart)?_c('v-chart',{ref:"unitCurve",staticClass:"!h-full !w-full",attrs:{"options":_vm.options,"autoresize":true}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }